import './styles.scoped.css';
import logo from '../../images/logo.png';
import {Link} from 'react-router-dom';
import { Col, Container, Row } from 'react-bootstrap';
import { Nav, Navbar, NavDropdown} from 'react-bootstrap';
interface HeaderProps {
};

const Header: React.FC<HeaderProps> = ({}) => {
  return (
  <Navbar expand="xl" className='header'>
      <Col className='logo' sm={3} lg={2}>
        <Link to={"/"}>
          <img className="logoimg" src={logo} alt="logo TeamBit" title="Logo TeamBit"/>
        </Link>
      </Col>
      <Navbar.Toggle aria-controls="basic-navbar-nav" className='custom-toggler'/>
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className='gap-3 d-flex align-items-center'>
            <Link to={"/hackathon"} className="ikona"> 
            <p>hackathon</p>
            </Link>
            <Link to={"/aktualnosci"} className="ikona"> 
            <p>wydarzenia</p>
            </Link>
            <Link to={"/contact"} className="ikona">
            <p>kontakt</p>
            </Link>
            <Link to={"/regulamin"} className="ikona">
              <p>regulamin</p>
            </Link>
        </Nav>
      </Navbar.Collapse>
  </Navbar>
  );
}

export default Header;
